<template>
  <LineChart :chartData="chartData" ref="chart" :options="chartOptions" :height="100"/>
</template>

<script>

import LineChart from './LineChart.js'

export default {
  props: ['requests', 'day'],
  data: () => {
    return {
      chartOptions: {
        legend: {display:false},
        scales: {
            xAxes: [{
              ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, values) {
                  return (value.endsWith(' 0h')?value:value); 
                }
              }
            }],
            yAxes: [{
              ticks: {
                max: 400,
                min: 0,
                stepSize: 100
              }
            }]
        }
      }
    }
  },
  mounted () {
    
  },
  computed: {
    chartData: function(){
      var c = {
        labels: [],
        datasets: [
          {
            label: 'Response time [ms]',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
      var date = new Date();
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      for(var i = (24*1)-1; i >= 0; i--){
        var time = new Date(date.getTime()-((i+((this.day-1)*24))*1000*60*60))
        c.labels.push(time.getDate()+"."+(time.getMonth()+1)+" "+time.getHours()+"h");
        time = this.getDateTime(time);
        var val = 0
        if(this.requests[time]) val = Math.round(this.requests[time].averageResponseTime)
        c.datasets[0].data.push(val)
      }
      return c;
    }
  },
  methods: {
    getDateTime: function(v){
      return v.getFullYear() +
        '-' + this.pad(v.getMonth() + 1) +
        '-' + this.pad(v.getDate()) +
        'T' + this.pad(v.getHours()) +
        ':' + this.pad(v.getMinutes()) +
        ':' + this.pad(v.getSeconds());
    },
    pad: function(number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    }
  },
  components: {
    LineChart
  }
}
</script>